import { render, staticRenderFns } from "./InputDicomize.vue?vue&type=template&id=5b1eb473&"
import script from "./InputDicomize.vue?vue&type=script&lang=js&"
export * from "./InputDicomize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports